<template>
  <div>
    <the-section :title="$t('ec-line011.shippingFormTitlte')" :is-modal="isEcLine011Flag ? false : true">
      <template #subTitle>
        <span class="text-base lg:text-xs">{{ $t('common.requiredItem') }}</span>
      </template>
      <el-form ref="form" :model="form" label-position="top" :rules="rules">
        <span v-if="corporateFlag || !businessAccountFlag">
          <el-form-item :label="$t('common.memberInformation.fullName')" required>
            <div class="flex space-x-2 items-center">
              <el-form-item prop="name01" class="name-form">
                <el-input
                  v-model="form.name01"
                  :placeholder="$t('common.informationPlaceholder.lastNamePlaceholder')"
                  :maxlength="16"
                ></el-input>
              </el-form-item>
              <el-form-item prop="name02" class="name-form">
                <el-input
                  v-model="form.name02"
                  :placeholder="$t('common.informationPlaceholder.firstNamePlaceholder')"
                  :maxlength="20"
                ></el-input>
              </el-form-item>
            </div>
          </el-form-item>

          <el-form-item :label="$t('common.memberInformation.nameKana')" required>
            <div class="flex space-x-2 items-center">
              <el-form-item prop="kana01" class="name-form">
                <el-input
                  v-model="form.kana01"
                  :placeholder="$t('common.informationPlaceholder.lastNameKanaPlaceholder')"
                  :maxlength="40"
                ></el-input>
              </el-form-item>
              <el-form-item prop="kana02" class="name-form">
                <el-input
                  v-model="form.kana02"
                  :placeholder="$t('common.informationPlaceholder.firstNameKanaPlaceholder')"
                  :maxlength="40"
                ></el-input>
              </el-form-item>
            </div>
          </el-form-item>
        </span>
        <span v-else>
          <el-form-item
            :label="$t('common.memberInformation.companyName')"
            prop="company_name"
            class="is-required"
            required
          >
            <el-input
              v-model="form.company_name"
              :placeholder="$t('common.informationPlaceholder.exampleCompanyName')"
              :maxlength="32"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="$t('common.memberInformation.companyNameKana')"
            prop="company_name_kana"
            class="is-required"
            required
          >
            <el-input
              v-model="form.company_name_kana"
              :placeholder="$t('common.informationPlaceholder.exampleCompanyNameKana')"
              :maxlength="32"
            ></el-input>
          </el-form-item>
        </span>
        <div class="lg:flex items-center mb-">
          <el-form-item
            :label="$t('common.memberInformation.postalCode')"
            prop="postal_code"
            class="postal-code-item"
            required
          >
            <div class="flex items-center space-x-4">
              <el-form-item prop="postalCodeRule" class="flex items-center space-x-2 mb-0 postal-code-form">
                <div class="flex">
                  <el-input
                    inputmode="numeric"
                    v-model="form.postal_code01"
                    :placeholder="$t('common.informationPlaceholder.postalCodeFirstPlaceholder')"
                    :maxlength="3"
                    v-replace-half-width
                    class="postal-code01"
                    @blur="getAddress"
                    @change="onChangePostalCodeForm"
                  ></el-input>
                  <div class="mx-1.5 mt-2 text-center">{{ $t('common.hyphenSeparator') }}</div>
                  <el-input
                    inputmode="numeric"
                    v-model="form.postal_code02"
                    :placeholder="$t('common.informationPlaceholder.postalCodeLastPlaceholder')"
                    :maxlength="4"
                    v-replace-half-width
                    class="postal-code02"
                    @blur="getAddress"
                    @change="onChangePostalCodeForm"
                  ></el-input>
                </div>
              </el-form-item>
            </div>
          </el-form-item>
          <div class="mb-5 text-gray-950 text-xs font-normal lg:leading-none">
            {{ $t('common.informationPlaceholder.postalCodeTip') }}
          </div>
        </div>

        <el-form-item :label="$t('common.memberInformation.prefectures')" prop="pref_id" class="mb-8">
          <el-select v-model="form.pref_id" :placeholder="$t('common.pleaseSelect')">
            <el-option v-for="item in prefectures" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('common.memberInformation.addr01')" prop="addr01" class="mb-8">
          <el-input
            v-model="form.addr01"
            :placeholder="$t('common.informationPlaceholder.municipalitiesPlaceholder')"
            :maxlength="40"
            v-replace-half-width
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('common.memberInformation.addr02')" prop="addr02" class="mb-8">
          <el-input
            v-model="form.addr02"
            :placeholder="$t('common.informationPlaceholder.addressPlaceholder')"
            :maxlength="40"
            v-replace-half-width
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('common.memberInformation.addr03')" prop="addr03" class="mb-8">
          <el-input
            v-model="form.addr03"
            :placeholder="$t('common.informationPlaceholder.buildingApartmentNamePlaceholder')"
            :maxlength="40"
            v-replace-half-width
          ></el-input>
        </el-form-item>

        <div class="lg:flex items-center">
          <el-form-item
            :label="$t('common.memberInformation.phoneNumber')"
            prop="phone_number"
            class="mb-4 phone-number-item"
            required
          >
            <div class="flex items-center">
              <div class="phone-number">
                <el-input
                  inputmode="numeric"
                  v-model="form.phone_number"
                  :placeholder="$t('common.informationPlaceholder.phoneNumberPlaceholder')"
                  :maxlength="11"
                ></el-input>
              </div>
            </div>
          </el-form-item>
          <div class="text-gray-950 text-xs font-normal mb-4">
            {{ $t('common.messages.phoneNumberInputRules') }}
          </div>
        </div>
      </el-form>
    </the-section>
    <div class="check-box-section mt-5 lg:mt-10">
      <div class="items-center flex">
        <el-checkbox v-model="form.is_update_customer" class="flex items-center">
          <span class="break-words whitespace-normal">
            {{ $t('common.addressList.checkbox.isUpdateCustomer') }}
          </span>
        </el-checkbox>
      </div>
      <div class="items-center mt-2 lg:mt-4">
        <el-checkbox v-model="form.is_default">
          <span class="items-center break-words whitespace-normal">
            {{ $t('common.addressList.checkbox.isDefaultShipping.label') }}
          </span>
        </el-checkbox>
        <div class="text-xs">{{ $t('common.addressList.checkbox.isDefaultShipping.description') }}</div>
      </div>
    </div>
    <div class="flex flex-col items-center lg:flex-row justify-center mt-5 lg:mt-10 lg:mb-4">
      <el-button class="submit-btn lg:ml-6 lg:order-1" @click="onSubmit">{{
        id ? $t('ec-line011.updateBtn') : $t('ec-line011.addBtn')
      }}</el-button>
      <el-button class="cancel-btn mt-5 mb-1 lg:my-0" @click="onCancel">{{ $t('common.action.cancel') }}</el-button>
    </div>
    <div v-if="id" class="flex flex-col items-center mt-2 mb-1 lg:mt-7 lg:mb-4 lg:flex-row justify-center">
      <el-button class="delete-btn" @click="openDeleteDialog">{{ $t('ec-line011.deleteBtn') }}</el-button>
    </div>

    <confirm-delete-dialog
      :visible.sync="confirmDeleteVisible"
      :yes-handler="onDelete"
      :no-handler="onCancelDeleting"
    ></confirm-delete-dialog>
  </div>
</template>

<script>
import { AddressService, PostCodeJpService } from '@/services'
import TheSection from '@/components/my-page-partials/TheSection.vue'
import ConfirmDeleteDialog from '../ConfirmDeleteDialog.vue'
import { changeHalfNumber, isValidPostalCode, toHalfWidth, trimCommaForm, trimForm } from '@/utils'
import { cloneDeep } from 'lodash'

export default {
  components: { TheSection, ConfirmDeleteDialog },
  props: {
    id: { type: [Number, String], default: () => null },
    isEcLine011Flag: { type: Boolean, required: false, default: () => false },
  },
  data() {
    const postalCodeValidator = async (rule, value, callback) => {
      const formValue = trimForm(this.form)
      const postalCode01 = formValue.postal_code01
      const postalCode02 = formValue.postal_code02

      if (postalCode01 && postalCode02 && isValidPostalCode({ postalCode01, postalCode02 })) {
        callback()
      } else if (
        (!postalCode01 && !postalCode02) ||
        !postalCode01 ||
        postalCode01.length < 3 ||
        !postalCode02 ||
        postalCode02.length < 4
      ) {
        callback(new Error(this.$t('common.validate.cmn-err-001', [this.$t('common.validate.field.postalCode')])))
      }
    }
    return {
      form: {
        name01: '',
        name02: '',
        kana01: '',
        kana02: '',
        postal_code: '-',
        postal_code01: '',
        postal_code02: '',
        pref_id: null,
        addr01: '',
        addr02: '',
        addr03: null,
        phone_number: '',
        is_update_customer: false,
        is_default: true,
        company_name: '',
        company_name_kana: '',
      },
      unwatchAddressId: null,
      addressInfoDefault: {},
      rules: {
        name01: [this.Utils.validate.required(this.$t('common.validate.field.lastName'))],
        name02: [this.Utils.validate.required(this.$t('common.validate.field.firstName'))],
        kana01: [
          this.Utils.validate.required(this.$t('common.validate.field.lastNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.lastNameKana')),
        ],
        kana02: [
          this.Utils.validate.required(this.$t('common.validate.field.firstNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.firstNameKana')),
        ],
        postalCodeRule: [{ validator: postalCodeValidator, trigger: ['change', 'blur'] }],
        pref_id: [this.Utils.validate.required(this.$t('common.validate.field.prefecture'), ['change'])],
        addr01: [this.Utils.validate.required(this.$t('common.validate.field.municipality'))],
        addr02: [this.Utils.validate.required(this.$t('common.validate.field.address'))],
        phone_number: [
          this.Utils.validate.required(this.$t('common.validate.field.phoneNumber')),
          this.Utils.validate.numberFormat(this.$t('common.validate.field.phoneNumber')),
          this.Utils.validate.phoneFormat(),
        ],
        company_name: [this.Utils.validate.required(this.$t('common.validate.field.companyName'))],
        company_name_kana: [
          this.Utils.validate.required(this.$t('common.validate.field.companyNameKana')),
          this.Utils.validate.kanaFormat(this.$t('common.validate.field.companyNameKana')),
        ],
      },
      confirmDeleteVisible: false,
    }
  },
  computed: {
    prefectures() {
      return this.$store.state.master.pref
    },
    corporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
    businessAccountFlag() {
      return this.$store.getters['auth/user']?.business_account_flag
    },
  },
  watch: {
    id: {
      handler() {
        this.fetchData()
      },
      immediate: true,
    },
  },
  created() {
    this.unwatchAddressId = this.$watch('id', () => {
      this.fetchData()
      this.unwatchAddressId()
    })
  },
  methods: {
    async fetchData() {
      if (this.id) {
        const loading = this.$loading({ lock: true })
        try {
          const { data } = await AddressService.getAddressDetail(this.id)

          const postalPattern = /(\d{3})[-]?(\d+)/
          const match = data.postal_code.match(postalPattern)
          this.form = Object.assign({
            ...this.form,
            name01: data.name01,
            name02: data.name02,
            kana01: data.kana01,
            kana02: data.kana02,
            postal_code: data.postal_code,
            postal_code01: match?.[1] || '',
            postal_code02: match?.[2] || '',
            pref_id: data.pref.id,
            addr01: data.addr01,
            addr02: data.addr02,
            addr03: data.addr03,
            phone_number: this.Utils.helper.getOnlyNumber(data.phone_number),
            company_name: this.corporateFlag
              ? data.company_name
              : this.businessAccountFlag
              ? data.name01 + (data.name02 || '')
              : '',
            company_name_kana: this.businessAccountFlag ? data.kana01 + (data.kana02 || '') : '',
          })

          this.addressInfoDefault = cloneDeep(this.form)
        } catch (error) {
          this.$router.push({ name: '404' })
        } finally {
          loading.close()
        }
      }
    },
    async getAddress() {
      this.onChangePostalCodeForm()

      this.$refs.form.validateField('postal_code')
      if (!this.form.postal_code01?.trim() || !this.form.postal_code02?.trim()) return

      const res = await PostCodeJpService.getAddress({
        postalCode: this.form.postal_code01 + this.form.postal_code02,
      })

      if (!res) return

      this.form.pref_id = this.prefectures.find((item) => item.name === res.prefecture)?.id
      this.form.addr01 = toHalfWidth(res.municipality)
      this.form.addr02 = toHalfWidth(res.addr02)
    },
    onChangePostalCodeForm() {
      this.form = {
        ...this.form,
        postal_code01: changeHalfNumber(this.form.postal_code01),
        postal_code02: changeHalfNumber(this.form.postal_code02),
      }
    },
    async onSubmit() {
      if (!this.corporateFlag && this.businessAccountFlag) {
        this.form.name01 = this.form.company_name
        this.form.name02 = ''
        this.form.kana01 = this.form.company_name_kana
        this.form.kana02 = ''
      }
      this.form = trimCommaForm(trimForm(this.form))
      this.$nextTick(() => {
        this.$refs.form.validate(async (valid) => {
          if (!valid) {
            this.handleError({
              message: this.$t('common.messages.hasInvalidData'),
            })

            return
          }

          const data = Object.assign({
            ...this.form,
            postal_code: `${this.form.postal_code01}-${this.form.postal_code02}`,
          })
          this.isChangeAddrInfo()

          this.$emit('submit', data)
        })
      })
    },
    onCancel() {
      this.$emit('cancel')
    },
    onDelete() {
      this.$emit('delete')
      this.$emit('update-inquiry-status')
    },
    isChangeAddrInfo() {
      this.addressInfoDefault = trimCommaForm(trimForm(this.addressInfoDefault))
      const hasDiffInfo = Object.keys(this.addressInfoDefault).filter((key) => {
        return this.addressInfoDefault[key] !== this.form[key]
      })

      if (hasDiffInfo.length) {
        this.$emit('update-inquiry-status')
      }
    },
    openDeleteDialog() {
      this.confirmDeleteVisible = true
    },
    onCancelDeleting() {
      this.confirmDeleteVisible = false
    },
  },
}
</script>

<style scoped>
.el-form-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  .el-form-item__label {
    font-size: 16px;
  }
}
.check-box-section {
  width: 311px;
  margin: 0 auto;
  @media screen and (min-width: 1200px) {
    width: 356px;
  }
}
.phone-number {
  width: 100%;
}
.postal-code-form {
  width: 156px;
}
.postal-code01 {
  width: 65px;
}
.postal-code02 {
  width: 80px;
}

/* PC時のレイアウト (ラベルとフォーム横並び) */
@media screen and (min-width: 1200px) {
  .el-form-item {
    width: 660px;
    flex-direction: row;
    align-items: center;
    &.postal-code-item {
      width: 500px;
      label.el-form-item__label {
        width: 163px;
        margin-right: 12px;
      }
      .el-form-item__content {
        width: 160px;
      }
    }
    &.phone-number-item {
      width: 330px;
      label.el-form-item__label {
        width: 163px;
        margin-right: 12px;
      }
      .el-form-item__content {
        width: 145px;
      }
      .el-form-item__error {
        width: 160px;
      }
    }
    label {
      width: 163px;
      margin-right: 12px;
    }
    .el-form-item__content {
      width: 485px;
    }
  }
  .name-form {
    width: 238.5px;
  }
}
</style>
